import React, { useEffect } from 'react'
import { styles } from './TooltipStyles'
import { withStyles } from '@material-ui/core'
import InfoButton from '../icons/InfoButton'
import ReactTooltip from 'react-tooltip'

const Tooltip = props => {
  const { classes, tooltipId, tooltipText, offset, place = 'top', children } = props

  useEffect(() => {
    const handleScroll = () => ReactTooltip.hide()
    window.addEventListener('scroll', handleScroll, true)
    return () => window.removeEventListener('scroll', handleScroll, true)
  }, [])

  return (
    <div className={classes.tooltipWrap}>
      {children ? (
        <span data-for={tooltipId} data-tip={tooltipText}>
          {children}
        </span>
      ) : (
        <InfoButton dataFor={tooltipId} dataTip={tooltipText} />
      )}
      <ReactTooltip
        className={classes.tooltip}
        effect="solid"
        place={place}
        html
        {...(offset && { offset })}
        type="dark"
        id={tooltipId}
      />
    </div>
  )
}

export default withStyles(styles)(Tooltip)
